import React from 'react';
import { Menu } from 'antd';

const DropdownMenu = ({
  items,
  onMenuClick,
  idKey = 'id',
  contentKey = 'name',
  menuClassName,
  itemClassName,
  stageMassAction = false,
  ...props
}) => {
  const handleMenuClick = ({ domEvent, key }) => {
    domEvent.stopPropagation();
    onMenuClick(key);
  };

  return (
    <Menu
      {...props}
      className={menuClassName}
      onClick={handleMenuClick}
    >
      {items?.map((item) => (
        <Menu.Item
          disabled={!item.available && stageMassAction}
          className={itemClassName}
          key={item[idKey]}
        >
          {item[contentKey]}
        </Menu.Item>
      ))}
    </Menu>
  );
};

export default DropdownMenu;
